@if (instance()) {
  <div [ngClass]="minified() ? 'pl-8' : 'pl-4'">
    <span class="bg-ui-green-light p-1 px-2 rounded text-white uppercase font-semibold text-xs h-5">
      {{ instance() }}
    </span>
  </div>
}
